import "../App.css";
// import Header from "../component/header/index.jsx";
import Footer from "../component/footer/index.jsx";
// import { useParams, useLocation, useSearchParams } from "react-router-dom";
// import { useAuthContext } from "../AuthContext";
import { useState } from "react";
import AboutSlider from "../component/AboutSlider/AboutSlider";
import { SLIDER_CONTENT } from "../data/SliderData/slider";
import { motion } from "framer-motion";
import { LazyMotion, domAnimation } from "framer-motion";

function About() {
  const [slide, setSlide] = useState(0);
  // const params = useLocation();
  // console.log(params);
  // const { isMobile } = useAuthContext();
  // console.log("is mobile", isMobile);
  // const search = useLocation().search;
  // const referAddress = new URLSearchParams(search).get("referral");
  // console.log(referAddress);
  // localStorage.setItem("referAddress", referAddress);

  const handleSlides = (param) => {
    switch (param) {
      case "right":
        if (slide === SLIDER_CONTENT.length - 1) {
          setSlide(0);
        } else {
          setSlide(slide + 1);
        }
        break;
      case "left":
        if (slide === 0) {
          setSlide(SLIDER_CONTENT.length - 1);
        } else {
          setSlide(slide - 1);
        }
        break;

      default:
        break;
    }
  };

  return (
    <LazyMotion features={domAnimation}>
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="App">
          <section className="creative-sec about-creative-sec ">
            <div className="container-1280 ">
              <div className="row">
                <div className="col-lg-6">
                  <h1 className="stylish-txt">Creative</h1>
                  <h2 className="white-color lg-txt">Meets Technology</h2>
                </div>
                <div className="col-lg-6">
                  <div className="sec-1-imgs">
                    <span className="puzzle">
                      <img src={require("../Assets/img/game2.png")} alt="" />
                    </span>
                    <img src={require("../Assets/img/sec1.png")} alt="" />
                    <img src={require("../Assets/img/sec1-2.png")} alt="" />
                    <img src={require("../Assets/img/sec1-3.png")} alt="" />
                    <img src={require("../Assets/img/sec1-4.png")} alt="" />
                    <span className="game">
                      <img src={require("../Assets/img/game.png")} alt="" />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="lines">
              <img src={require("../Assets/img/purple-line.png")} alt="" />
              <img src={require("../Assets/img/pink-line.png")} alt="" />
            </div>
          </section>
          <section className="text-section">
            <div className="container-1280">
              <div className="row">
                <div className="col-lg-10">
                  <p>
                    It is a long established fact that a reader will be
                    distracted by the readable content of a page when looking at
                    its layout. The point of using. It is a long established
                    fact that a reader will be distracted by the readable
                    content of{" "}
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className="create-section">
            <div className="container-1280">
              <div className="row">
                <div className="col-lg-12">
                  <h2 className="gradient-txt">
                    We Strive To <span>Create</span>
                  </h2>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="code-img right-sec  ">
              <img
                src={require("../Assets/img/code.png")}
                className="img-fluid"
                alt=""
              />
            </div>
          </section>

          <section className="slider-container">
            <div className="container-1280">
              <div className="row">
                <div className="col-lg-12">
                  <h2 className="gradient-txt">
                    We Are <span> Mythical</span>
                  </h2>
                  <span className="gradient-bar">
                    <img
                      src={require("../Assets/img/bar.png")}
                      className="img-fluid"
                      alt=""
                    />
                  </span>
                </div>
                <div className="slider-sec-new">
                  <AboutSlider
                    paragraph={SLIDER_CONTENT[slide]?.paragraph}
                    firstname={SLIDER_CONTENT[slide]?.firstname}
                    lastname={SLIDER_CONTENT[slide]?.lastname}
                    designation={SLIDER_CONTENT[slide]?.designation}
                    image={SLIDER_CONTENT[slide]?.image}
                  />
                  <div className="arrow-div">
                    <img
                      src={require("../Assets/img/left.png")}
                      className="img-fluid"
                      onClick={() => handleSlides("left")}
                      alt=""
                    />
                    <img
                      src={require("../Assets/img/right.png")}
                      className="img-fluid"
                      onClick={() => handleSlides("right")}
                      alt=""
                    />
                  </div>
                </div>

                <div className="images-list">
                  <div>
                    <img
                      src={require("../Assets/img/img1.png")}
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div>
                    <img
                      src={require("../Assets/img/img2.png")}
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div>
                    <img
                      src={require("../Assets/img/img3.png")}
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div>
                    <img
                      src={require("../Assets/img/img4.png")}
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="lines-slider">
              <img src={require("../Assets/img/sky-bar.png")} alt="" />
              <img src={require("../Assets/img/pink-bar.png")} alt="" />
            </div>
          </section>
          <div className="border-radius">
            <section className="contact-sec">
              <div className="container-1280">
                <div className="row">
                  <div className="col-lg-6">
                    <h2 className="gradient-txt f-42">Come Build With Us</h2>
                  </div>
                  <div className="col-lg-6">
                    <div className="get-started">
                      <input
                        type="text"
                        id="fname"
                        name="fname"
                        placeholder="John"
                      />
                      <input type="submit" value="Submit" />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <Footer />
      </motion.div>
    </LazyMotion>
  );
}

export default About;
